import fakeUserImagePNG from '~/img/fake-user-image.png';
import { Contract, Currency } from '~/features/dashboard/store/models';
import * as uuid from 'uuid';

export const fakeMoney: Contract[] = [
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'SONY RCA',
            logo: fakeUserImagePNG,
        },
        name: 'PUBLISHING',
        amount: 2450,
        createDate: '3/31/2020',
        nextStatementDate: '9/30/2020',
        status: 'UP_TO_DATE',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'DOWNTOWN',
            logo: fakeUserImagePNG,
        },
        name: 'PUBLISHING',
        amount: 0,
        createDate: '3/31/2020',
        nextStatementDate: '9/30/2020',
        status: 'OUTSTANDING',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'INTERSCOPE',
            logo: fakeUserImagePNG,
        },
        name: 'RECORD ROYALTIES',
        amount: 8650,
        createDate: '3/31/2020',
        nextStatementDate: '9/30/2020',
        status: 'UP_TO_DATE',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'VIRGIN',
            logo: fakeUserImagePNG,
        },
        name: 'RECORD ROYALTIES',
        amount: -968,
        createDate: '3/31/2020',
        nextStatementDate: '9/30/2020',
        status: 'UP_TO_DATE',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'DEF JAM',
            logo: fakeUserImagePNG,
        },
        name: 'RECORD ROYALTIES',
        amount: 0,
        createDate: '3/31/2020',
        nextStatementDate: '9/30/2020',
        status: 'OUTSTANDING',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'SONY ATV',
            logo: fakeUserImagePNG,
        },
        name: 'PUBLISHING',
        amount: -541,
        createDate: '3/31/2020',
        nextStatementDate: '9/30/2020',
        status: 'UP_TO_DATE',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'UMPG',
            logo: fakeUserImagePNG,
        },
        name: 'PUBLISHING',
        amount: -75421,
        createDate: '3/31/2020',
        nextStatementDate: '10/13/2020',
        status: 'UP_TO_DATE',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'SOUND EXCHANGE',
            logo: fakeUserImagePNG,
        },
        name: 'NEIGHBOURING RIGHT',
        amount: 11489,
        createDate: '8/17/2020',
        nextStatementDate: '10/13/2020',
        status: 'UP_TO_DATE',
        amountCurrency: Currency.USD,
    },
    {
        id: uuid.v4(),
        company: {
            id: uuid.v4(),
            name: 'PPL',
            logo: fakeUserImagePNG,
        },
        name: 'PERFORMANCE',
        amount: 5476,
        createDate: '8/17/2020',
        nextStatementDate: '',
        status: 'UP_TO_DATE',
        amountCurrency: Currency.USD,
    },
];
